import { call, put, takeLatest } from "redux-saga/effects";
import * as types from "./CapacityvsDemandTableActionType";
import * as actions from "./CapacityvsDemandTableAction";
import * as services from "./CapacityvsDemandTableService";
import SweetAlert from "../../../components/sweetalert/SweetAlert";
import { downloadBase64File } from "../../../utils/fileDownloads";

//------Fetch Capacity vs Demand DD List Saga ----//
function* fetchCapacityReportDDList() {
  try {
    const response = yield call(services.fetchCapacityVSDemandDDList);

    if (response?.success) {
      yield put(actions.fetchCapacityDDListSuccess(response));

      // SweetAlert.success({
      //     title: 'Success!',
      //     text: response?.resultMessage
      // });
    } else {
      yield put(
        actions.fetchCapacityDDListFailure("Failed to fetch dropdown list"),
      );
      SweetAlert.error({
        title: "Error!",
        text: response?.errorMessage,
      });
    }
  } catch (error) {
    console.error("Fetch Capacity Report DD List Error:", error);

    yield put(
      actions.fetchCapacityDDListFailure(
        error?.message || "Failed to fetch dropdown list",
      ),
    );
    SweetAlert.error({
      title: "Error!",
      text: "Failed to fetch Capacity Reports dropdown list.",
    });
  }
}

//-----Fetch Capacity vs Demand Report List saga---------//
function* fetchCapacityVsDemandSaga(action) {
  try {
    const response = yield call(
      services.fetchCapacityVSDemandReportData,
      action.payload,
    );

    if (response?.success) {
      yield put(actions.fetchCapsVsDemandReportSuccess(response));

      // SweetAlert.success({
      //     title: 'Success!',
      //     text: response?.resultMessage
      // });
    } else {
      yield put(
        actions.fetchCapsVsDemandReportFailure("Failed to fetch report data"),
      );
      SweetAlert.error({
        title: "Error!",
        text: response?.errorMessage,
      });
    }
  } catch (error) {
    console.error("Fetch Capacity Vs Demand Report Error:", error);

    yield put(actions.fetchCapsVsDemandReportFailure(error?.message));
    SweetAlert.error({
      title: "Error!",
      text: "Failed to fetch Reports data.",
    });
  }
}

//-------Fetch Legend Data---//
function* fetchLegendDataSaga(action) {
  try {
    const response = yield call(services.fetchLegendData, action.payload);

    if (response?.success) {
      yield put(actions.fetchLegendDataSuccess(response));

      // SweetAlert.success({
      //     title: 'Success!',
      //     text: response?.resultMessage
      // });
    } else {
      yield put(actions.fetchLegendDataFailure("Failed to fetch legend data"));

      SweetAlert.error({
        title: "Error!",
        text: response?.errorMessage,
      });
    }
  } catch (error) {
    console.error("Fetch Legend Data Error:", error);

    yield put(
      actions.fetchLegendDataFailure(
        error?.message || "Failed to fetch legend data",
      ),
    );

    SweetAlert.error({
      title: "Error!",
      text: error?.message || "Failed to fetch legend data.",
    });
  }
}

//-------Fetch Available Shift Filter DDList---//
function* fetchAvailableShiftDDList(action) {
  try {
    const response = yield call(
      services.fectchAvailableFilterDDList,
      action.payload,
    );

    if (response?.success) {
      yield put(actions.fetchAvailableshiftFilterDDListSuccess(response));

      // SweetAlert.success({
      //     title: 'Success!',
      //     text: response?.resultMessage
      // });
    } else {
      yield put(actions.fetchAvailableshiftFilterDDListFailure());
      SweetAlert.error({
        title: "Error!",
        text: response?.errorMessage,
      });
    }
  } catch (error) {
    console.error("Fetch Available Shift DD List Error:", error);

    yield put(
      actions.fetchAvailableshiftFilterDDListFailure(
        error?.message || "Failed to fetch available shift dropdown list",
      ),
    );

    SweetAlert.error({
      title: "Error!",
      text: error?.message || "Failed to fetch available shift dropdown list.",
    });
  }
}

//-------Fetch Available Shift Data---//
function* fetchAvailableShiftDataSaga(action) {
  try {
    const response = yield call(
      services.fecthAvailabeshiftData,
      action.payload,
    );

    if (response?.success) {
      yield put(actions.fectchAvailableShiftSuccess(response));

      // SweetAlert.success({
      //     title: 'Success!',
      //     text: response?.resultMessage
      // });
    } else {
      yield put(
        actions.fectchAvailableShiftFailure(
          "Failed to fetch Available Shift data",
        ),
      );

      SweetAlert.error({
        title: "Error!",
        text: response?.errorMessage,
      });
    }
  } catch (error) {
    console.error("Fetch Available Shift Data Error:", error);

    yield put(
      actions.fectchAvailableShiftFailure(
        error?.message || "Failed to fetch Available Shift data",
      ),
    );

    SweetAlert.error({
      title: "Error!",
      text: "Failed to fetch Available Shift data.",
    });
  }
}

//-------Fetch Available Shift RPCE Data---//
function* fetchAvailableShiftRPCESaga(action) {
  try {
    const response = yield call(
      services.fetchAvailableShiftData,
      action.payload,
    );

    if (response?.success) {
      yield put(actions.fetchAvailableShiftRPCESuccess(response));

      // SweetAlert.success({
      //     title: 'Success!',
      //     text: response?.resultMessage
      // });
    } else {
      yield put(
        actions.fetchAvailableShiftRPCEFailure(
          "Failed to fetch available shift data",
        ),
      );

      SweetAlert.error({
        title: "Error!",
        text: response?.errorMessage,
      });
    }
  } catch (error) {
    console.error("Fetch Available Shift RPCE Error:", error);

    yield put(
      actions.fetchAvailableShiftRPCEFailure(
        error?.message || "Failed to fetch available shift data",
      ),
    );

    SweetAlert.error({
      title: "Error!",
      text: "Failed to fetch Reports data.",
    });
  }
}

//-----Fetch Available Shift Worklist Data---------//
function* fetchAvailableShiftWorklistSaga(action) {
  try {
    const response = yield call(
      services.fetchAvailableShiftWorklist,
      action.payload,
    );

    if (response?.success) {
      yield put(actions.fetchAvailableShiftWorklistSuccess(response));

      // SweetAlert.success({
      //     title: 'Success!',
      //     text: response?.resultMessage
      // });
    } else {
      yield put(
        actions.fetchAvailableShiftWorklistFailure(
          "Failed to fetch worklist data",
        ),
      );

      SweetAlert.error({
        title: "Error!",
        text: response?.errorMessage,
      });
    }
  } catch (error) {
    console.error("Fetch Available Shift Worklist Error:", error);

    yield put(
      actions.fetchAvailableShiftWorklistFailure(
        error?.message || "Failed to fetch worklist data",
      ),
    );

    SweetAlert.error({
      title: "Error!",
      text: "Failed to fetch Reports data.",
    });
  }
}

//-------Fetch RPCE DATA in CspVsDemand tab---//
function* fetchCapsVsDemandRPCESaga(action) {
  try {
    const response = yield call(
      services.fetchCapsVsDemandShiftRPCE,
      action.payload,
    );

    if (response?.success) {
      yield put(actions.fetchCapsVsDemandShiftRPCESuccess(response));

      // SweetAlert.success({
      //     title: 'Success!',
      //     text: response?.resultMessage
      // });
    } else {
      yield put(
        actions.fetchCapsVsDemandShiftRPCEFailure(
          "Failed to fetch report data",
        ),
      );

      SweetAlert.error({
        title: "Error!",
        text: response?.errorMessage,
      });
    }
  } catch (error) {
    console.error("Fetch Caps Vs Demand RPCE Error:", error);

    yield put(
      actions.fetchCapsVsDemandShiftRPCEFailure(
        error?.message || "Failed to fetch report data",
      ),
    );

    SweetAlert.error({
      title: "Error!",
      text: "Failed to fetch Reports data.",
    });
  }
}

//-------Fetch Worklist DATA in CspVsDemand tab---//
function* fetchCapsVsDemandWorklistSaga(action) {
  try {
    const response = yield call(
      services.fetchCapsVsDemandShiftWorklist,
      action.payload,
    );

    if (response?.success) {
      yield put(actions.fetchCapsVsDemandShiftWorklistSuccess(response));

      // SweetAlert.success({
      //     title: 'Success!',
      //     text: response?.resultMessage
      // });
    } else {
      yield put(
        actions.fetchCapsVsDemandShiftWorklistFailure(
          "Failed to fetch worklist data",
        ),
      );

      SweetAlert.error({
        title: "Error!",
        text: response?.errorMessage,
      });
    }
  } catch (error) {
    console.error("Fetch Caps Vs Demand Worklist Error:", error);

    yield put(
      actions.fetchCapsVsDemandShiftWorklistFailure(
        error?.message || "Failed to fetch worklist data",
      ),
    );

    SweetAlert.error({
      title: "Error!",
      text: "Failed to fetch Reports data.",
    });
  }
}

//--------Fetch Capacity Details in CapsVsDemand tab on popup---//
function* fetchCapacityDetailsSaga(action) {
  try {
    const response = yield call(
      services.fetchCapacityPopupDetails,
      action.payload,
    );

    if (response?.success) {
      yield put(actions.fetchCapacityPopupDetailsSuccess(response));

      // SweetAlert.success({
      //     title: 'Success!',
      //     text: response?.resultMessage
      // });
    } else {
      yield put(
        actions.fetchCapacityPopupDetailsFailure(
          "Failed to fetch capacity details",
        ),
      );

      SweetAlert.error({
        title: "Error!",
        text: response?.errorMessage,
      });
    }
  } catch (error) {
    console.error("Fetch Capacity Details Error:", error);

    yield put(
      actions.fetchCapacityPopupDetailsFailure(
        error?.message || "Failed to fetch capacity details",
      ),
    );

    SweetAlert.error({
      title: "Error!",
      text: "Failed to fetch Reports data.",
    });
  }
}

//--------Fetch Worklist Details in CapsVsDemand tab on popup---//
function* fetchWorklistDetailsSaga(action) {
  try {
    const response = yield call(
      services.fetchWorklistDetailsData,
      action.payload,
    );

    if (response?.success) {
      yield put(actions.fetchWorklistDetailSuccess(response));

      // SweetAlert.success({
      //     title: 'Success!',
      //     text: response?.resultMessage
      // });
    } else {
      yield put(
        actions.fetchWorklistDetailFailure("Failed to fetch worklist details"),
      );

      SweetAlert.error({
        title: "Error!",
        text: response?.errorMessage,
      });
    }
  } catch (error) {
    console.error("Fetch Worklist Details Error:", error);

    yield put(
      actions.fetchWorklistDetailFailure(
        error?.message || "Failed to fetch worklist details",
      ),
    );

    SweetAlert.error({
      title: "Error!",
      text: "Failed to fetch Reports data.",
    });
  }
}

//-------Fetch Capacity Vs Demand Get By Id Details---//
function* fetchCapacityVsDemandDetailsByIdSaga(action) {
  try {
    const response = yield call(
      services.fetchCapacityVsDemandDetailsById,
      action.payload,
    );

    if (response?.success) {
      yield put(actions.fetchCapsVsDemandDetailsByIdSuccess(response));

      // SweetAlert.success({
      //     title: 'Success!',
      //     text: response?.resultMessage
      // });
    } else {
      yield put(
        actions.fetchCapsVsDemandDetailsByIdFailure(
          "Failed to fetch report details",
        ),
      );

      SweetAlert.error({
        title: "Error!",
        text: response?.errorMessage,
      });
    }
  } catch (error) {
    console.error("Fetch Capacity Vs Demand Details By Id Error:", error);

    yield put(
      actions.fetchCapsVsDemandDetailsByIdFailure(
        error?.message || "Failed to fetch report details",
      ),
    );

    SweetAlert.error({
      title: "Error!",
      text: "Failed to fetch Reports data.",
    });
  }
}

//-------Fetch Notes Details in CapsVsDemand ---//
function* fetchNotesDetailsByIdSaga(action) {
  try {
    const response = yield call(services.fetchNotesDetails, action.payload);

    if (response?.success) {
      yield put(actions.fetchCapsVsdemandNotesDetailsSuccess(response));

      // SweetAlert.success({
      //     title: 'Success!',
      //     text: response?.resultMessage
      // });
    } else {
      yield put(
        actions.fetchCapsVsdemandNotesDetailsFailure(
          "Failed to fetch notes details",
        ),
      );

      SweetAlert.error({
        title: "Error!",
        text: response?.errorMessage,
      });
    }
  } catch (error) {
    console.error("Fetch Notes Details Error:", error);

    yield put(
      actions.fetchCapsVsdemandNotesDetailsFailure(
        error?.message || "Failed to fetch notes details",
      ),
    );

    SweetAlert.error({
      title: "Error!",
      text: "Failed to fetch Reports notes data.",
    });
  }
}

//-------Save Notes Details in CapsVsDemand ---//
function* SaveCapsVsDemandNotesSaga(action) {
  try {
    const response = yield call(services.saveNotesRequest, action.payload);

    if (response?.success) {
      yield put(actions.saveCapsVsDemandNotesSuccess(response));

      yield put(
        actions.fetchCapsVsDemandReportRequest({
          SkipNoOfRecords: 0,
          perPage: 100,
          sSearch: "",
          sortField: "CapacityVsDemandTableID",
          sortOrder: "desc",
        }),
      );

      SweetAlert.success({
        title: "Success!",
        text: response?.resultMessage,
      });
    } else {
      yield put(actions.saveCapsVsDemandNotesFailure("Failed to save notes"));

      SweetAlert.error({
        title: "Error!",
        text: response?.errorMessage,
      });
    }
  } catch (error) {
    console.error("Save Caps Vs Demand Notes Error:", error);

    yield put(
      actions.saveCapsVsDemandNotesFailure(
        error?.message || "Failed to save notes",
      ),
    );

    SweetAlert.error({
      title: "Error!",
      text: "Failed to save notes.",
    });
  }
}

//-------Publish Capacity vs Demand Report---//
function* publishCapsVsDemandSaga(action) {
  try {
    const response = yield call(
      services.PublishCapsVsDemandReport,
      action.payload,
    );

    if (response?.success) {
      yield put(actions.PublishCapsVsDemandSuccess(response));

      const payload = {
        SkipNoOfRecords: 0,
        PageSize: 100,
        sSearch: "",
        sortColumn: "CapacityVsDemandTableID",
        sortColumnDir: "desc",
      };
      yield put(actions.fetchCapsVsDemandReportRequest(payload));

      SweetAlert.success({
        title: "Success!",
        text: response?.resultMessage,
      });
    } else {
      yield put(
        actions.PublishCapsVsDemandFailure({
          Message: response?.errorMessage || "Failed to publish report",
        }),
      );
      SweetAlert.error({
        title: "Error!",
        text: response?.errorMessage,
      });
    }
  } catch (error) {
    console.error("Publish Capacity Vs Demand Error:", error);
    yield put(
      actions.PublishCapsVsDemandFailure({
        Message: error?.message || "Failed to publish report",
      }),
    );
    SweetAlert.error({
      title: "Error!",
      text: error?.message || "Failed to publish report.",
    });
  }
}

//----------Export on RPCE data in Available shift---//
function* exportRPCEDataReportSaga(action) {
  try {
    const { CapacityVsDemandTableID, fileName } = action.payload;

    const response = yield call(
      services.exportRPCEDataRequest,
      CapacityVsDemandTableID,
    );

    if (response?.success) {
      const base64Data = response?.values || response?.data || response;

      if (!base64Data) {
        yield put(
          actions.exportRPCEDataAvailableShiftFailure("No export data found"),
        );

        SweetAlert.error({
          title: "Error!",
          text: "No data available to export.",
        });
        return;
      }

      yield call(downloadBase64File, base64Data, fileName);

      yield put(actions.exportRPCEDataAvailableShiftSuccess());

      SweetAlert.success({
        title: "Success!",
        text: response?.resultMessage,
      });
    } else {
      yield put(actions.exportRPCEDataAvailableShiftFailure("Export failed"));

      SweetAlert.error({
        title: "Error!",
        text: response?.errorMessage,
      });
    }
  } catch (error) {
    console.error("Export RPCE Data Error:", error);

    yield put(
      actions.exportRPCEDataAvailableShiftFailure(
        error?.message || "Export failed",
      ),
    );

    SweetAlert.error({
      title: "Error!",
      text: "Failed to export Capacity vs Demand Available Shifts RPCE Data.",
    });
  }
}

//----------Export on Worklist data in Available shift---//
function* exportWorklistDataReportSaga(action) {
  try {
    const { CapacityVsDemandTableID, fileName } = action.payload;

    const response = yield call(
      services.exportWorklistRequest,
      CapacityVsDemandTableID,
    );

    if (response?.success) {
      const base64Data = response?.values || response?.data || response;

      if (!base64Data) {
        throw new Error("No file data received");
      }

      yield call(downloadBase64File, base64Data, fileName);

      SweetAlert.success({
        title: "Success!",
        text: response?.resultMessage,
      });

      yield put(actions.exportWorklistDataAvailableShiftSuccess());
    } else {
      SweetAlert.error({
        title: "Error!",
        text: response?.errorMessage,
      });

      yield put(
        actions.exportWorklistDataAvailableShiftFailure(
          response?.errorMessage || "Export failed",
        ),
      );
    }
  } catch (error) {
    console.error("Export Worklist Data Error:", error);

    SweetAlert.error({
      title: "Error!",
      text:
        error?.message ||
        "Failed to export Capacity vs Demand Available Shifts data.",
    });

    yield put(
      actions.exportWorklistDataAvailableShiftFailure(
        error?.message || "Export failed",
      ),
    );
  }
}

//----------Export RPCE Data in Caps Vs Demnad tab---//
function* exportRPCEDataCapsVsDemandReportSaga(action) {
  try {
    const { CapacityVsDemandTableID, fileName } = action.payload;

    const response = yield call(
      services.exportRPCEDataCapsVsDemand,
      CapacityVsDemandTableID,
    );

    if (response?.success) {
      const base64Data = response?.values || response?.data;

      if (!base64Data) {
        throw new Error("No export data received");
      }

      yield call(downloadBase64File, base64Data, fileName);

      SweetAlert.success({
        title: "Success!",
        text: response?.resultMessage,
      });

      yield put(actions.exportRPCECapsVsDemandSuccess());
    } else {
      yield put(actions.exportRPCECapsVsDemandFailure("Export failed"));

      SweetAlert.error({
        title: "Error!",
        text: response?.errorMessage,
      });
    }
  } catch (error) {
    console.error("Export RPCE Capacity Vs Demand Error:", error);

    yield put(
      actions.exportRPCECapsVsDemandFailure(error?.message || "Export failed"),
    );

    SweetAlert.error({
      title: "Error!",
      text: "Failed to export Capacity vs Demand RPCE data.",
    });
  }
}

//----------Export Worklist Data in Caps Vs Demnad tab---//
function* exportWorklistDataCapsVsDemandSaga(action) {
  try {
    const { CapacityVsDemandTableID, fileName } = action.payload;

    const response = yield call(
      services.exportWorklistCapsVsDemandRequest,
      CapacityVsDemandTableID,
    );

    if (response?.success) {
      const base64Data = response?.values || response?.data || response;

      if (base64Data) {
        yield call(downloadBase64File, base64Data, fileName);
      }

      SweetAlert.success({
        title: "Success!",
        text: response?.resultMessage,
      });

      yield put(actions.exportWorklistCapsVsDemandSuccess());
    } else {
      yield put(
        actions.exportWorklistCapsVsDemandFailure("Failed to export data"),
      );

      SweetAlert.error({
        title: "Error!",
        text: response?.errorMessage,
      });
    }
  } catch (error) {
    console.error("Export Capacity Vs Demand Error:", error);

    yield put(
      actions.exportWorklistCapsVsDemandFailure(
        error?.message || "Failed to export data",
      ),
    );

    SweetAlert.error({
      title: "Error!",
      text: "Failed to export Capacity vs Demand Table Data.",
    });
  }
}

//-------Delete Capacity vs Demand Report---//
function* deleteCapsVsDemandSaga(action) {
  try {
    const { CapsVsdemandid } = action.payload;
    const response = yield call(
      services.deleteCapsVsdemandRequest,
      CapsVsdemandid,
    );

    if (response?.success) {
      yield put(actions.deleteCapsVsDemandSuccess(CapsVsdemandid));

      SweetAlert.success({
        title: "Success!",
        text: response?.resultMessage,
      });

      yield put(
        actions.fetchCapsVsDemandReportRequest({
          SkipNoOfRecords: 0,
          perPage: 100,
          sSearch: "",
          sortField: "CapacityVsDemandTableID",
          sortOrder: "desc",
        }),
      );
    } else {
      yield put(actions.deleteCapsVsDemandFailure("Failed to delete report"));

      SweetAlert.error({
        title: "Error!",
        text: response?.errorMessage,
      });
    }
  } catch (error) {
    console.error("Delete Capacity Vs Demand Report Error:", error);

    // Dispatch failure action
    yield put(
      actions.deleteCapsVsDemandFailure(
        error?.message || "Failed to delete report",
      ),
    );

    // Show error notification
    SweetAlert.error({
      title: "Error!",
      text: "Failed to delete Capacity Vs Demand report.",
    });
  }
}

//--------Export Capacity vs Demand Report---//
function* exportCapsVsDemandReportSaga(action) {
  try {
    const { CapacityVsDemandTableID, fileName } = action.payload;

    const response = yield call(
      services.exportCapacityVsDemandReport,
      CapacityVsDemandTableID,
    );

    if (response?.success) {
      const base64Data = response?.values || response;
      if (base64Data) {
        yield call(downloadBase64File, base64Data, fileName);
      }

      yield put(actions.exportCapsVsDemandReportSuccess());

      SweetAlert.success({
        title: "Success!",
        text: response?.resultMessage,
      });
    } else {
      yield put(
        actions.exportCapsVsDemandReportFailure("Failed to export report"),
      );

      SweetAlert.error({
        title: "Error!",
        text: response?.errorMessage,
      });
    }
  } catch (error) {
    console.error("Export Capacity Vs Demand Report Error:", error);

    yield put(
      actions.exportCapsVsDemandReportFailure(
        error?.message || "Failed to export report",
      ),
    );

    SweetAlert.error({
      title: "Error!",
      text: "Failed to export Capacity vs Demand report.",
    });
  }
}

function* watchCapsvsDemandSaga() {
  yield takeLatest(
    types.FETCH_CAPACITY_REPORT_DDLIST_REQUEST,
    fetchCapacityReportDDList,
  );
  yield takeLatest(
    types.FETCH_CAPACITYVsDEMAND_REPORT_REQUEST,
    fetchCapacityVsDemandSaga,
  );
  yield takeLatest(
    types.EXPORT_CAPSVSDEMAND_REPORT_REQUEST,
    exportCapsVsDemandReportSaga,
  );
  yield takeLatest(
    types.FETCH_AVAILABLE_SHIFT_REQUEST,
    fetchAvailableShiftDataSaga,
  );
  yield takeLatest(
    types.FETCH_AVAILABLE_SHIFT_RPCE_REQUEST,
    fetchAvailableShiftRPCESaga,
  );
  yield takeLatest(
    types.FETCH_AVAILABLE_SHIFT_FILTERDDLIST_REQUEST,
    fetchAvailableShiftDDList,
  );
  yield takeLatest(
    types.FETCH_AVAILABLESHIFT_LEGEND_REQUEST,
    fetchLegendDataSaga,
  );
  yield takeLatest(
    types.FETCH_AVAILABLE_WORKLISTDATA_REQUEST,
    fetchAvailableShiftWorklistSaga,
  );
  yield takeLatest(
    types.FETCH_RPCE_DATA_CAPSVSDEMAND_REQUEST,
    fetchCapsVsDemandRPCESaga,
  );
  yield takeLatest(
    types.FETCH_WORKLIST_DATA_CAPSVSDEMAND_REQUEST,
    fetchCapsVsDemandWorklistSaga,
  );
  yield takeLatest(
    types.DELETE_CAPSVSDEMAND_REPORT_REQUEST,
    deleteCapsVsDemandSaga,
  );
  yield takeLatest(
    types.FETCH_CAPACITY_HOVER_DETAILS_REQUEST,
    fetchCapacityDetailsSaga,
  );
  yield takeLatest(
    types.FETCH_WORKLIST_HOVER_DETAILS_REQUEST,
    fetchWorklistDetailsSaga,
  );
  yield takeLatest(
    types.FETCH_GETBY_ID_DETAILS_REQUEST,
    fetchCapacityVsDemandDetailsByIdSaga,
  );
  yield takeLatest(
    types.FETCH_CAPSVSDEMAND_NOTES_DETAILS_REQUEST,
    fetchNotesDetailsByIdSaga,
  );
  yield takeLatest(
    types.SAVE_CAPSVSDEMAND_NOTES_REQUEST,
    SaveCapsVsDemandNotesSaga,
  );
  yield takeLatest(
    types.PUBLISH_CAPSVSDEMAND_REPORT_REQUEST,
    publishCapsVsDemandSaga,
  );
  yield takeLatest(
    types.EXPORT_RPCE_DATA_AVAILABLESHIFT_REQUEST,
    exportRPCEDataReportSaga,
  );
  yield takeLatest(
    types.EXPORT_WORKLIST_DATA_AVAILABLESHIFT_REQUEST,
    exportWorklistDataReportSaga,
  );
  yield takeLatest(
    types.EXPORT_RPCE_CAPSVSDEMAND_REQUEST,
    exportRPCEDataCapsVsDemandReportSaga,
  );
  yield takeLatest(
    types.EXPORT_WORKLIST_CAPSVSDEMAND_REQUEST,
    exportWorklistDataCapsVsDemandSaga,
  );
}

export default watchCapsvsDemandSaga;
